import React from "react";

import { companyDashboardTopBarLink } from "Dashboard/EmployerUrls";
import { BasicLoading } from "ZeroRuby";

import { Body1 } from "Cobalt/BodyText";
import { Card } from "Cobalt/Card";
import Header from "Cobalt/Header";
import DashboardHeader from "Common/DashboardHeader";
import { Grid, Row, Col } from "Common/Grid";
import { appendAuthParams } from "Common/TokenAuth/Utils";

import { useGetToastCompaniesQuery } from "./api";

const LifecycleSection = (companyLifecycle, companyProfiles) => {
  return (
    <Card theme="flat">
      <Header level={7} mb={3}>
        {companyLifecycle}
      </Header>
      {companyProfiles.map((company) => {
        if (company.idToken) {
          let href;
          if (location.search.includes("employer_flow=")) {
            href = appendAuthParams(`/toast/router/update-segment/${company.id}${location.search}`);
          } else {
            href = `${companyDashboardTopBarLink(company.idToken.slice(0, 16))}${location.search}`;
          }
          return (
            <Body1 weight="bold" key={company.id} mb={2}>
              <a href={href}>
                {company.name} <i className="far fa-long-arrow-right" />
              </a>
            </Body1>
          );
        }
        return null;
      })}
    </Card>
  );
};

const FeinsSection = (feins) => {
  return (
    <Card>
      <Header level={7} mb={3}>
        Not started
      </Header>
      {feins.map((fein) => {
        return (
          <Body1 weight="bold" key={fein.remote_id} mb={2}>
            <a href={appendAuthParams(`/toast/router/toast-create-company/${fein.remote_id}${location.search}`)}>
              {fein.dba || fein.name} <i className="far fa-long-arrow-right" />
            </a>
          </Body1>
        );
      })}
    </Card>
  );
};

const MultipleCompanies = () => {
  const { data, isLoading } = useGetToastCompaniesQuery();
  if (isLoading) return <BasicLoading />;
  const { company_profiles: companyProfilesSorted, feins, email } = data;
  return (
    <Grid componentClass={Card} mt={5} p={0}>
      <Row>
        <Col>
          <DashboardHeader title="Please select the company you want to open" subtitle={email ? `Signed in as: ${email}` : ""} />

          {Object.keys(companyProfilesSorted).map((companyLifecycle) => {
            const companyProfiles = companyProfilesSorted[companyLifecycle];
            return LifecycleSection(companyLifecycle, companyProfiles);
          })}
          {feins.length > 0 && FeinsSection(feins)}
        </Col>
      </Row>
    </Grid>
  );
};

export default MultipleCompanies;
